import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  InputLabel,
  IconButton,
  InputAdornment,
  Tooltip,
  OutlinedInput,
  TextField,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { convertirTimestampEnHHMM } from "../../components/general/formatTime";
import ReplayIcon from "@material-ui/icons/Replay";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import InfoIcon from "@material-ui/icons/Info";

const sortOptions = [
  { key: "experience", label: (
    <div style={{ display: "flex", alignItems: "center" }}>
      Expériences
      <Tooltip
        title="Tri effectué selon l'expérience du bénévole pour la sous-activité choisie, puis selon son expérience générale toutes sous-activités confondues."
        arrow
      >
        <InfoIcon />
      </Tooltip>
    </div>
  ) },
  { key: "dispos", label: "Disponibilités" },
  { key: "date", label: "Dernière inscription" },
  { key: "alphabetique", label: "Alphabétique" },
];

const FilterForm = ({
  search,
  handleSearch,
  trie,
  handleSelectTrieChange,
  selectedParent,
  handleParentChange,
  chefOnIds,
  triCroissant,
  handleOrderChange,
  startDate,
  handleStartDateChange,
  startTime,
  handleStartTimeChange,
  endDate,
  handleEndDateChange,
  endTime,
  handleEndTimeChange,
  uniqueDates,
  uniqueStartTimes,
  uniqueEndDates,
  uniqueEndTimes,
  sousActiviteName,
  activeStep,
  setActiveStep,
  steps,
}) => {
  const hudelRefrshDates = () => {
    const e = { target: {} };
    e.target.value = "";
    handleStartDateChange(e);
    handleStartTimeChange(e);
    handleEndDateChange(e);
    handleEndTimeChange(e);
  };

  const isListeAttente = activeStep.type === "listeAttente";
  const isChefOnIdsEmpty = chefOnIds.length === 0;
  const styleFilterBox = {
    marginTop: isListeAttente ? 10 : 10,
    marginBottom: isListeAttente ? 20 : 10,
    width: "100%",
  };
  return (
    <div style={styleFilterBox}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6} md={3}>
          <FormControl fullWidth variant="outlined">
            <InputLabel>Statut</InputLabel>
            <Select
              value={activeStep?.type ?? ""}
              onChange={(e) => {
                setActiveStep(
                  steps.find((step) => step.type === e.target.value)
                );
              }}
              displayEmpty
              label="Statut"
            >
              {steps?.map((step) => (
                <MenuItem key={step.type} value={step.type}>
                  {step.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} md={3} style={styleFilterBox}>
          <FormControl fullWidth variant="outlined">
            <InputLabel>{sousActiviteName || ""}</InputLabel>
            <Select
              value={
                isListeAttente
                  ? ""
                  : isChefOnIdsEmpty
                  ? ""
                  : selectedParent?.id || chefOnIds[0]?.ID || ""
              }
              onChange={handleParentChange}
              displayEmpty
              label={sousActiviteName || ""}
              error={isChefOnIdsEmpty}
              disabled={isListeAttente}
            >
              {chefOnIds?.map((activite, index) => (
                <MenuItem key={index} value={activite.ID}>
                  {activite.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} md={3}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>Tri</InputLabel>
            <Select
              value={trie}
              onChange={(e) => handleSelectTrieChange(e)}
              input={
                <OutlinedInput
                  label="Tri"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={(e) => handleOrderChange(e)}>
                        {triCroissant ? (
                          <Tooltip title="Trier par ordre croissant" arrow>
                            <ArrowUpwardIcon />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Trier par ordre décroissant" arrow>
                            <ArrowDownwardIcon />
                          </Tooltip>
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              }
            >
              {sortOptions.map((option) => (
                <MenuItem key={option.key} value={option.key}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            label="Recherche"
            variant="outlined"
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            fullWidth
          />
        </Grid>
      </Grid>

      {/* Accordéon pour les filtres avancés */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Filtres Avancés</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid
              container
              justifyContent="flex-end"
              style={{ maxHeight: "10px" }}
            >
              <IconButton
                onClick={hudelRefrshDates}
                style={{ borderRadius: "50%" }}
                title="Vider la recherche avancée"
              >
                <ReplayIcon />
              </IconButton>
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Date de début</InputLabel>
                <Select
                  value={startDate ?? ""}
                  onChange={handleStartDateChange}
                  displayEmpty
                  fullWidth
                  label="Date de début"
                >
                  <MenuItem key={"124b"} value={""}></MenuItem>

                  {uniqueDates.map((date, index) => (
                    <MenuItem key={index} value={date}>
                      {date}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControl variant="outlined">
                <InputLabel>Heure de début</InputLabel>
                <Select
                  value={startTime ?? ""}
                  onChange={handleStartTimeChange}
                  displayEmpty
                  style={{ width: "220px" }}
                  label="Heure de début"
                >
                  <MenuItem key={"124c"} value={""}></MenuItem>
                  {uniqueStartTimes.map((time, index) => (
                    <MenuItem key={index} value={time}>
                      {convertirTimestampEnHHMM(time)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Date de fin</InputLabel>
                <Select
                  value={endDate ?? ""}
                  onChange={handleEndDateChange}
                  displayEmpty
                  fullWidth
                  label="Date de fin"
                >
                  <MenuItem key={"124d"} value={""}></MenuItem>
                  {uniqueDates.map((date, index) => (
                    <MenuItem key={index} value={date}>
                      {date}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControl variant="outlined">
                <InputLabel>Heure de fin</InputLabel>
                <Select
                  value={endTime ?? ""}
                  onChange={handleEndTimeChange}
                  displayEmpty
                  style={{ width: "220px" }}
                  label="Heure de fin"
                >
                  <MenuItem key={"124e"} value={""}></MenuItem>
                  {uniqueEndTimes.map((time, index) => (
                    <MenuItem key={index} value={time}>
                      {convertirTimestampEnHHMM(time)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default FilterForm;
